module.exports = __webpack_public_path__ + "img/koenen5-min.6611e62b.jpg";